import { initSwipers } from "src/vendors/swiper";

import type { Swiper } from "swiper";
import type { InitSwiperProps } from "src/vendors/swiper";

const PRODUCT_CAROUSEL_SETTINGS: InitSwiperProps = {
  wrapperSelector: ".product-images-carousel__wrapper",
  containerSelector: ".product-images-carousel",
  paginationSelector: ".product-images-carousel__pagination",
  prevButtonSelector: ".product-images-carousel__button-prev",
  nextButtonSelector: ".product-images-carousel__button-next",
  scrollBarSelector: ".product-images-carousel__scrollbar",
};

function toggleScrollbar(swiper: Swiper) {
  const scrollbarNode = swiper.scrollbar?.el;
  if (!scrollbarNode || !(scrollbarNode instanceof HTMLElement)) return;

  clearTimeout((swiper as any)._paginationHideTimeout);

  scrollbarNode.classList.remove("is-hidden");

  (swiper as any)._paginationHideTimeout = setTimeout(() => {
    scrollbarNode.classList.add("is-hidden");
  }, 2000);
}

function initProductSwipers() {
  initSwipers(PRODUCT_CAROUSEL_SETTINGS, {
    loop: false,
    spaceBetween: 10,
    on: {
      slideChange() {
        toggleScrollbar(this);
      },
      touchStart() {
        toggleScrollbar(this);
      },
    },
  });
}

/*
  Fixes bug
  When collection products updated (After filters applied and DOM content changed with new html)
*/
document.addEventListener("products:loaded", function () {
  initProductSwipers();
});

/*
  For first initialization collection products swipers
*/
document.addEventListener("DOMContentLoaded", () => {
  initProductSwipers();
});
